// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2cOac","label":"Radio_label__ilusn","checkMark":"Radio_checkMark__1xo7k","disabled":"Radio_disabled__XusMf"};